var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrowLeftBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.35216 4.49304C8.4986 4.63949 8.4986 4.87692 8.35216 5.02337L5.12552 8.25H15.3748C15.5819 8.25 15.7498 8.4179 15.7498 8.625V9.375C15.7498 9.58211 15.5819 9.75 15.3748 9.75H5.12383L8.35215 12.9783C8.4986 13.1248 8.4986 13.3622 8.35215 13.5087L7.82182 14.039C7.67538 14.1854 7.43794 14.1854 7.29149 14.039L2.51853 9.26601C2.37208 9.11956 2.37208 8.88213 2.51853 8.73568L7.2915 3.96271C7.43794 3.81626 7.67538 3.81626 7.82183 3.96271L8.35216 4.49304Z",
  fill: "#464A51"
})));
export default SvgIconArrowLeftBlack;